"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("swr"),
    r = e(t),
    n = require("swr-mutate-many"),
    s = require("param-case"),
    i = require("url"),
    o = e(require("camelcase")),
    a = require("react");

let u = process.env.API_NETWORK_BASE_URL || process.env.REACT_APP_API_NETWORK_BASE_URL || process.env.EXPO_API_NETWORK_BASE_URL || "/api/v2/";

class c extends Error {
  constructor(e, t) {
    super(e), this.message = e, Object.setPrototypeOf(this, c.prototype), Error.captureStackTrace && Error.captureStackTrace(this, c), this.data = t;
  }

}

class d extends Error {
  constructor(e, t) {
    super(e), this.message = e, Object.setPrototypeOf(this, d.prototype), Error.captureStackTrace && Error.captureStackTrace(this, d), this.data = t;
  }

}

const l = {
  method: "GET",
  headers: {
    "Content-Type": "application/vnd.api+json",
    Accept: "application/vnd.api+json"
  },
  credentials: "include",
  mode: "cors"
};

let p = async e => e;

async function f(e, t) {
  const r = t && t.controller ? t.controller : new AbortController(),
        n = await p(l),
        s = await fetch(i.resolve(u, e), { ...(n || {}),
    ...(t || {}),
    headers: { ...((n || {}).headers || {}),
      ...((t || {}).headers || {})
    },
    signal: r.signal
  });
  if (s.status >= 400 && s.status <= 499) throw new c("API Client Error", await s.json());
  if (s.status >= 500 && s.status <= 599) throw new d("API Server Error", await s.text());
  if (204 !== s.status) return await s.json();
}

function h(e, t, r = {}) {
  const n = {
    type: e
  };
  return r.relationships ? (n.attributes = function (e, t) {
    return Object.keys(t).reduce((r, n) => (e.includes(n) || (r[n] = t[n]), r), {});
  }(r.relationships.map(e => "string" == typeof e ? e + "Id" : e.name + "Id"), t), n.relationships = r.relationships.reduce((e, r) => {
    const n = "string" == typeof r ? r : r.name,
          s = "string" == typeof r ? r : r.resource,
          i = t[n + "Id"];
    if (i) if (Array.isArray(i)) {
      const t = i.map(e => ({
        id: e,
        type: s + "s"
      }));
      e[n] = {
        data: t
      };
    } else e[n] = {
      data: {
        id: i,
        type: s + "s"
      }
    };
    return e;
  }, n.relationships || {}), {
    data: n
  }) : (n.attributes = t, {
    data: n
  });
}

function y(e) {
  return e.split(".").map(e => s.paramCase(e)).join(".");
}

function m(e) {
  const t = s.paramCase(e.resource.toLowerCase()),
        r = e.relationship ? s.paramCase(e.relationship.toLowerCase()) : void 0,
        {
    id: n
  } = e;
  if (!n && r) throw new Error("You can't pass a relationship name without and ID.");
  if (n && e.filters) throw new Error("You can't filter a single resource.");
  if (n && e.sort) throw new Error("You can't sort a single resource.");
  if (n && e.page) throw new Error("You can't paginate a single resource.");
  if (r && e.included) throw new Error("You can't use included when formating a URL for a relationship.");
  const i = [t],
        a = [];
  return n && i.push(String(n)), r && i.push("relationships/" + r), e.included && e.included.length > 0 && a.push("include=" + e.included.map(e => e.split(".").map(e => o(e)).join(".")).join(",")), e.filters && Object.keys(e.filters).length > 0 && a.push(Object.entries(e.filters).filter(([e, t]) => void 0 !== t).map(([e, t]) => "filter[" + e + "]=" + function (e) {
    return Array.isArray(e) ? e.join(",") : String(e);
  }(t)).join("&")), e.sort && e.sort.length > 0 && a.push("sort=" + e.sort.map(e => {
    if (e.startsWith("-")) return ["DESC", e];
    const [t, r] = e.split(" ");
    return r || "DESC" === t || "ASC" === t ? [t.toUpperCase(), r] : ["ASC", t];
  }).map(([e, t]) => "DESC" === e ? "-" + y(t) : y(t)).join(",")), e.fields && Object.keys(e.fields).length > 0 && a.push(Object.entries(e.fields).filter(([e, t]) => void 0 !== t).map(([e, t]) => "fields[" + e + "]=" + t.join(",")).join("&")), e.page && Object.keys(e.page).length > 0 && a.push(Object.entries(e.page).filter(([e, t]) => void 0 !== t).map(([e, t]) => "page[" + e + "]=" + t).join("&")), i.join("/") + (a.length > 0 ? "?" + a.join("&") : "");
}

function g(e) {
  return Array.isArray(e) ? e : [e];
}

function w(e) {
  const {
    data: t = [],
    included: r = []
  } = e;
  return [...g(t), ...r].map(e => {
    const {
      type: t,
      id: r,
      attributes: n = {},
      relationships: s = {}
    } = e,
          i = {
      id: String(r),
      type: o(t),
      ...n
    };

    for (let e in s) {
      const t = s[e];
      i[e] = null != t && t.data ? t.data : null;
    }

    return [o(t), i];
  }).reduce((e, [t, r]) => {
    var n;
    const {
      id: s,
      ...i
    } = r;
    if (!s || "undefined" === s) return e;
    const o = null != (n = e[t]) ? n : {
      ids: [],
      entities: {}
    };
    return o.ids.push(s), o.entities[s] = {
      id: s,
      ...i
    }, { ...e,
      [t]: o
    };
  }, {});
}

function E(e, t, r = !1) {
  const n = w(e);
  if (!n[t]) return [];
  const s = n[t].ids.map(e => n[t].entities[e]).map(e => function e(t, r, n = r) {
    const s = {
      id: r.id
    };

    for (let i in r) {
      if ("id" === i) continue;
      const o = r[i];

      if ("object" != typeof o) {
        s[i] = o;
        continue;
      }

      const a = [];

      for (const r of g(o)) "object" == typeof r && null !== r && Object.keys(r).every(e => "id" === e || "type" === e) ? a.push(r.type === n.type && r.id === n.id ? n : {
        type: r.type,
        ...e(t, t[r.type].entities[r.id], n)
      }) : a.push(r);

      s[i] = 1 === a.length ? a[0] : a;
    }

    return s;
  }(n, e));
  return 1 !== s.length || r ? s : s[0];
}

function b(e, t, r, n) {
  switch (e) {
    case "denormalized":
      return E(t, r, !!n);

    case "normalized":
      return w(t);

    default:
      return t;
  }
}

const j = new Proxy({}, {
  get(e, r) {
    const n = s.paramCase(r);

    async function i({
      included: e = [],
      sort: r = [],
      filters: s = {},
      fields: i = {},
      page: o = {}
    } = {}, u = {}, c = "none") {
      const d = m({
        resource: n,
        filters: s,
        included: e,
        sort: r,
        fields: i,
        page: o
      }),
            l = await f(d, u);
      return a(l, {
        filters: s,
        included: e,
        sort: r,
        fields: i,
        page: o
      }, c), t.mutate([c, d, n]), l;
    }

    function o(e, {
      included: t = [],
      sort: r = [],
      fields: n = {},
      page: s = {}
    } = {}, o = {}) {
      return i({
        filters: e,
        included: t,
        sort: r,
        fields: n,
        page: s
      }, o);
    }

    async function a(e, {
      included: r = [],
      filters: s = {},
      sort: i = [],
      fields: o = {},
      page: a = {}
    } = {}, u = "none") {
      const c = m({
        resource: n,
        included: r,
        filters: s,
        sort: i,
        fields: o,
        page: a
      });
      return t.cache.set([u, c, n], b(u, e, n, !0), !0), await e;
    }

    async function u(e, r = [], {
      fields: s = {}
    } = {}, i = {}, o = "none") {
      const a = m({
        resource: n,
        fields: s
      }),
            u = await f(a, { ...i,
        method: "POST",
        body: JSON.stringify(h(n, e, {
          relationships: r
        }))
      });
      return t.mutate([o, a, n]), u;
    }

    return {
      read: i,
      find: function (e) {
        async function r(r, {
          included: s = [],
          fields: i = {}
        } = {}, o = "none") {
          const a = m({
            resource: n,
            id: e,
            included: s,
            fields: i
          });
          return t.cache.set([o, a, n], b(o, r, n, !0), !0), await r;
        }

        async function i(r, s = {}, i = "none") {
          const o = m({
            resource: n,
            id: e
          }),
                a = await f(o, { ...s,
            method: "PATCH",
            body: JSON.stringify({
              data: {
                type: n,
                id: e,
                attributes: r
              }
            })
          });
          return t.mutate([i, o, n]), a;
        }

        return i.relation = async function (r, i, o = {}, a = "none") {
          const u = m({
            resource: n,
            id: e,
            relationship: s.paramCase(r)
          }),
                c = await f(u, { ...o,
            method: "PATCH",
            body: JSON.stringify({
              data: i
            })
          });
          return t.mutate([a, u, n]), c;
        }, {
          read: async function ({
            included: s = [],
            fields: i = {}
          } = {}, o = {}, a = "none") {
            const u = m({
              resource: n,
              id: e,
              included: s,
              fields: i
            }),
                  c = await f(u, o);
            return r(c, {
              included: s,
              fields: i
            }, a), t.mutate([a, u, n]), c;
          },
          update: i,
          upsert: function (t, r, n = [], s = {}, o = "none") {
            return e ? i(t, s, o) : u({ ...t,
              ...r
            }, n, {}, s, o);
          },
          destroy: async function (r = {}, s = "none") {
            const i = m({
              resource: n,
              id: e
            });
            await f(i, { ...r,
              method: "DELETE"
            }), t.mutate([s, i, n]);
          },
          hydrate: r
        };
      },
      findAll: function ({
        included: e = [],
        sort: t = [],
        fields: r = {},
        page: n = {}
      } = {}, s = {}) {
        return i({
          included: e,
          sort: t,
          fields: r,
          page: n
        }, s);
      },
      findBy: function (e, t, r = {}, n = {}) {
        return o({
          [e]: t
        }, r, n);
      },
      where: o,
      create: u,
      hydrate: a
    };
  }

});

class C extends a.Component {
  constructor() {
    super(...arguments), this.state = {
      hasError: !1,
      error: new Error()
    };
  }

  static getDerivedStateFromError(e) {
    return {
      error: e,
      hasError: !0
    };
  }

  componentDidCatch(e, t) {
    this.props.onError && this.props.onError(e, t);
  }

  render() {
    const {
      fallback: e,
      children: t
    } = this.props,
          {
      hasError: r,
      error: n
    } = this.state;
    return r ? a.createElement(e, {
      error: n
    }) : t;
  }

}

C.defaultProps = {
  fallback: function () {
    return null;
  }
};
const S = "undefined" == typeof window;

class x extends a.Component {
  render() {
    const {
      fallback: e
    } = this.props;
    return S ? e : a.createElement(a.Suspense, Object.assign({
      fallback: e
    }, this.props));
  }

}

function O(e, t, r) {
  switch (e) {
    case "denormalized":
      return async function (e, t) {
        return E(await f(e), o(t), !0);
      }(t, r);

    case "normalized":
      return async function (e) {
        return w(await f(e));
      }(t);

    default:
      return f(t);
  }
}

function A(e, t, r) {
  switch (e) {
    case "denormalized":
      return async function (e, t) {
        return E(await f(e), o(t), !1);
      }(t, r);

    case "normalized":
      return async function (e) {
        return w(await f(e));
      }(t);

    default:
      return f(t);
  }
}

x.defaultProps = {
  fallback: null
}, Object.keys(n).forEach(function (e) {
  "default" !== e && Object.defineProperty(exports, e, {
    enumerable: !0,
    get: function () {
      return n[e];
    }
  });
}), Object.defineProperty(exports, "cache", {
  enumerable: !0,
  get: function () {
    return t.cache;
  }
}), exports.ClientError = c, exports.ErrorBoundary = C, exports.SSRSuspense = x, exports.ServerError = d, exports.api = j, exports.buildURL = m, exports.denormalize = E, exports.network = f, exports.normalize = w, exports.resetConfigure = function () {
  p = async e => e;
}, exports.setBaseURL = function (e) {
  u = e;
}, exports.setConfigure = function (e) {
  p = e;
}, exports.useCollection = function (e, {
  included: t = [],
  filters: n = {},
  sort: s = [],
  fields: i = {},
  page: o = {},
  options: a = {}
} = {}, u = "none") {
  return r([u, m({
    resource: e,
    included: t,
    filters: n,
    sort: s,
    fields: i,
    page: o
  }), e], O, {
    suspense: !0,
    ...a
  });
}, exports.useDenormalize = function (e, t) {
  return a.useMemo(() => E(e, o(t)), [e, t]);
}, exports.useNormalize = function (e) {
  return a.useMemo(() => w(e), [e]);
}, exports.useResource = function (e, t, {
  included: n = [],
  relationship: s,
  fields: i = {},
  options: o = {}
} = {}, a = "none") {
  return r([a, m({
    resource: e,
    id: t,
    included: n,
    relationship: s,
    fields: i
  }), e], A, {
    suspense: !0,
    ...o
  });
};